import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import * as s from './styled-modal-confirmation';

const ModalConfirmation = ({
  id = 'modal-confimacao',
  onClose,
  labelTitle,
  labelConfirmation,
  labelClose,
  onCloseConfirmation,
}) => {
  const { colors } = useContext(ThemeContext);

  return (
    <s.Modal id={id} role="dialog" aria-modal="true">
      <s.Container>
        <s.Elemento position="absolute" align="end" width="33%">
          <s.ButtonClose
            type="button"
            aria-label="Fechar"
            onClick={() => onCloseConfirmation(false)}
          >
            X
          </s.ButtonClose>
        </s.Elemento>
        <s.Text>{labelTitle || 'Deseja confirmar a modificação?'}</s.Text>
        <s.Line>
          <s.Button type="button" color={colors.lightblue} onClick={onClose}>
            {labelConfirmation || 'CONFIRMAR'}
          </s.Button>
          <s.Button
            type="button"
            color={colors.label}
            onClick={() => onCloseConfirmation(false)}
          >
            {labelClose || 'CANCELAR'}
          </s.Button>
        </s.Line>
      </s.Container>
    </s.Modal>
  );
};

export default ModalConfirmation;
